import { type RouteRecordRaw } from 'vue-router';

import { License } from '../../models';

export const liveRoutes: RouteRecordRaw[] = [{
    path: 'live',
    name: 'live',
    redirect: { name: 'live.casts' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 5,
        index: 0,
        licenses: {
            operator: 'or',
            licenses: [License.SPOT_AUDIO, License.SPOT_SCENT, License.SPOT_VIDEO]
        },
        prependIcon: 'icon-now',
        code: 'core.routes.menu.live'
    },
    component: () => import('./views/LiveView.vue'),
    children: [{
        path: 'casts/create',
        name: 'live.casts.create',
        meta: {
            index: 0,
            code: 'core.routes.live.casts.create',
            breadcrumbs: true
        },
        component: () => import('./views/live/CreateCastView.vue')
    }, {
        path: 'casts',
        name: 'live.casts',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'core.routes.live.casts'
        },
        component: () => import('./views/live/CastsView.vue')
    }, {
        path: 'triggers/:triggerId',
        name: 'live.triggers.trigger',
        meta: {
            index: 1,
            code: 'core.routes.live.triggers.trigger',
            breadcrumbs: true
        },
        component: () => import('./views/live/TriggerView.vue')
    }, {
        path: 'children/:triggerId',
        name: 'live.triggers.children-trigger',
        meta: {
            index: 0,
            code: 'core.routes.live.triggers.children-trigger',
            breadcrumbs: true
        },
        component: () => import('./views/live/ChildrenTriggerView.vue')
    }, {
        path: 'shared/:triggerId',
        name: 'live.triggers.shared-trigger',
        meta: {
            index: 1,
            code: 'core.routes.live.triggers.shared-trigger',
            breadcrumbs: true
        },
        component: () => import('./views/live/SharedTriggerView.vue')
    }, {
        path: 'triggers',
        name: 'live.triggers',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'core.routes.live.triggers'
        },
        component: () => import('./views/live/TriggersView.vue')
    }]
}];